import React, { createContext, useState } from "react";

export const OperacaoContext = createContext();

export const OperacaoProvider = ({ children }) => {
  const [operacoes, setOperacoes] = useState([]);
  return (
    <OperacaoContext.Provider value={{ operacoes, setOperacoes }}>
      {children}
    </OperacaoContext.Provider>
  );
};
